import GeoJSON from 'ol/format/GeoJSON';
import { MAP_PAGE, VIEW_OBSERVATION_PAGE } from 'client/utils/routes/routeConstants';
import { FeaturesService, ObservationService } from 'client/services';
import { redirect } from 'react-router';

const action = async ({ request }) => {
    const formData = await request.formData();
    const submittedObservation = formData.get('submittedObservation');

    if (submittedObservation) {
        const parsed = JSON.parse(submittedObservation);
        if (parsed?.systemId) {
            // Editing an existing observation
            const updatedObservation = await ObservationService.editObservation(parsed);
            return redirect(`${VIEW_OBSERVATION_PAGE}/${updatedObservation.systemId}`);
        } else {
            // Creating a new observation
            // We could redirect to the view page here, too
            // but then when they go back to the map it won't have reloaded the AOI
            // so it would look like the observation hadn't been saved until they redraw it
            await ObservationService.createObservation(parsed);
            return redirect(`${MAP_PAGE}/?reloadAOI=true`);
        }
    } else {
        const formFields = Object.fromEntries(formData);
        const geometry = JSON.parse(formFields.geometry);
        const aoi = new GeoJSON().readFeature({ geometry, type: 'Feature' });
        const draftObservation = JSON.parse(formData.get('draftObservation')) || {};

        const { features: featuresByAssetType, sensitiveFeatures } = await FeaturesService.getFeatures(aoi);

        return {
            aoiContainsSensitiveFeatures: (sensitiveFeatures.length > 0),
            geometry,
            featuresByAssetType,
            aoi,
            draftObservation
        };
    }
};

export default action;
